import React, { useCallback, useMemo, useReducer } from 'react';

import shareConstants    from './share.constants';
import ShareContext      from './share.context';
import shareReducer      from './share.reducer';
import shareInitialState from './share.state';

/**
 * @type {React.FC}
 */

const ShareProvider = function({
  children,
  value = shareInitialState,
}) {
  const [state, dispatch] = useReducer(shareReducer, value);

  const hideModal = useCallback(() => {
    dispatch({ type: shareConstants.HIDE_MODAL });
  }, [dispatch]);

  const showModal = useCallback(
    () => {
      dispatch({
        type: shareConstants.SHOW_MODAL,
      });
    },
    [dispatch],
  );

  const addLink = useCallback((link) => {
    dispatch({
      type:    shareConstants.ADD_LINK,
      payload: link,
    });
  }, [dispatch]);

  const closeLoading = useCallback(() => {
    dispatch({
      type: shareConstants.LOADING_SUCCESS,
    });
  }, [dispatch]);

  const context = useMemo(
    () => ({
      ...state,
      hideModal,
      showModal,
      addLink,
      closeLoading,
    }),
    [hideModal, showModal, addLink, closeLoading, state],
  );

  return (
    <ShareContext.Provider value={context}>{children}</ShareContext.Provider>
  );
};

export default ShareProvider;
